import axios from "axios";

const instance = axios.create({
     // baseURL: "http://localhost:5001/favouritedoctor-7a5fa/us-central1/dashboard" //API url(cloud function)
     baseURL: "https://us-central1-favouritedoctor-7a5fa.cloudfunctions.net/dashboard"
});

export default instance;